import script from "./LoadBeforeOrderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadBeforeOrderModal.vue?vue&type=script&setup=true&lang=js"

import "./LoadBeforeOrderModal.vue?vue&type=style&index=0&id=b29da7ac&lang=scss"

const __exports__ = script;

export default __exports__